import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FetchCategories } from '../../store/reducers/cake_category_reducer';

const List = React.memo(({ items }) => {
  return items.map((item, index) => (
    <option key={index} value={item?.id}>
      {item?.name}
    </option>
  ));
});

const CakeCategory = ({ category, onChange, label, name, ...rest }) => {
  const categoryList = useSelector((state) => state?.cake_categories?.categories);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FetchCategories());
  }, [dispatch]);

  return (
    <Form.Select
      required={'required' in rest ? rest.required : false}
      disabled={'disabled' in rest ? rest.disabled : false}
      name={name}
      value={category}
      onChange={onChange}
      aria-label="Floating label select example"
      className="form-select"
    >
      <option value="">Select {label}</option>
      <List items={categoryList} />
    </Form.Select>
  );
};

export default React.memo(CakeCategory);
